// @ts-nocheck
import urls from "../urls";
import {BACKOFFICE_ORIGIN, SHIFT4_JS_ORIGIN} from "../securionpayOrigins";
import SecurionPay from "./SecurionPay"

if (document.currentScript) {
    // @ts-ignore
    const loadedFrom = urls.getOrigin(document.currentScript.src);
    if (loadedFrom !== SHIFT4_JS_ORIGIN) {
        throw new Error(`Shift4.js have to be loaded from '${SHIFT4_JS_ORIGIN}', but was '${loadedFrom}'.`);
    }
}

window.Shift4 = SecurionPay;